import { FacetComponentProps } from "../../FacetItem";
import styles from "./TextFacet.module.scss";

export const TextFacet = ({ facetDetails }: FacetComponentProps) => (
  <span className={styles.text} data-testid="text-facet">
    {facetDetails.label} ({facetDetails.qty})
  </span>
);
